import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import _partial from 'lodash/partial'
import _isString from 'lodash/isString'
import { getBoundActions } from '../../actions/index'
import EmailCapture from '../EmailCapture/index'
import Link, { TARGET_BLANK } from '../Link/index'
import { get as getConfig } from '../../config/index'
import { connect as connectStaticText } from '../StaticText/connect'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_LINK } from '../ButtonSignUp/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'

function renderEmailCapture (props, onClose, showEmailCapture) {
  const {
    video, staticText, emailSignup, doEmailSignup,
  } = props
  const siteSegment = video.getIn(['data', 'siteSegment'], Map())
  const introtext = staticText.getIn(['data', 'introText'])
  const pathIsGive = _isString(video.get('path'))
    ? video.get('path').slice(0, 5) === '/give'
    : false
  const formName = pathIsGive ? 'shareView' : 'PREVIEW_POPUP'

  if (showEmailCapture) {
    return (
      <div className="video-email-capture__email-capture-wrapper">
        <Button
          type={TYPES.LINK}
          onClick={onClose}
          className="video-email-capture__close"
        >
          <IconV2 type={ICON_TYPES.CLOSE} />
        </Button>
        <div className="video-email-capture__email-capture-input-wrapper">
          <div className="video-email-capture__email-capture-input-inner-wrapper">
            <div className="video-email-capture__email-capture-introtext">
              {introtext}
            </div>
            <EmailCapture
              buttonText={staticText.getIn(['data', 'submit'])}
              inputPlaceholder={staticText.getIn(['data', 'yourEmail'])}
              formName={formName}
              success={emailSignup.get('success')}
              siteSegment={siteSegment}
              onFormSubmit={doEmailSignup}
              uiLocation="Video Preview"
            />
            <div className="video-email-capture__footer">
              <Link
                to={getConfig().origin}
                className="video-email-capture__footer-link"
                target={TARGET_BLANK}
              >
                {staticText.getIn(['data', 'exploreGaia'])}
              </Link>
              <ButtonSignUp
                type={BUTTON_SIGN_UP_TYPE_LINK}
                text={staticText.getIn(['data', 'signUpNow'])}
                className="video-email-capture__footer-link"
                target={TARGET_BLANK}
                scrollToTop
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}

function renderSignUpBanner (
  props,
  showEmailCapture,
  emailSignupSuccess,
  signUpClick,
) {
  const { emailCaptureBannerHeight, staticText } = props
  const bannerStyles = { height: emailCaptureBannerHeight }
  const questionText = staticText.getIn(['data', 'enjoyingVideo'])
  const signUpLinkText = staticText.getIn(['data', 'getMoreFromGaia'])
  if (showEmailCapture || !emailSignupSuccess) {
    return (
      <div className="video-email-capture__banner" style={bannerStyles}>
        <span className="video-email-capture__question-text">
          {`${questionText} `}
        </span>
        <span
          onClick={signUpClick}
          className="video-email-capture__sign-up-link"
        >
          {signUpLinkText}
        </span>
      </div>
    )
  }
  return (
    <div
      className="video-email-capture__banner-placeholder"
      style={bannerStyles}
    />
  )
}
class VideoEmailCapture extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showEmailCapture: false,
    }
  }

  onSignUpClick = () => {
    this.setState(() => ({ showEmailCapture: true }))
  }

  onSignUpCloseClick = () => {
    this.setState(() => ({ showEmailCapture: false }))
  }

  render () {
    const { props } = this
    const { state } = this
    const { emailSignup } = props
    const { showEmailCapture } = state
    const emailSignupSuccess = emailSignup.get('success')
    const onSignUpClickPartial = _partial(this.onSignUpClick)
    const onSignUpCloseClickPartial = _partial(this.onSignUpCloseClick)

    return (
      <div className="video-email-capture">
        {renderSignUpBanner(
          props,
          showEmailCapture,
          emailSignupSuccess,
          onSignUpClickPartial,
        )}
        {renderEmailCapture(props, onSignUpCloseClickPartial, showEmailCapture)}
      </div>
    )
  }
}

VideoEmailCapture.propTypes = {
  emailCaptureBannerHeight: PropTypes.number,
  doEmailSignup: PropTypes.func.isRequired,
  emailSignup: ImmutablePropTypes.map.isRequired,
  video: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({
    storeKey: 'videoEmailCapture',
  }),
  connect(
    (state) => ({
      emailSignup: state.emailSignup,
      video: state.video,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignup,
      }
    },
  ),
)(VideoEmailCapture)
